import { useState, useEffect } from "react";

import API from "utils/api";

export default function useRules() {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);

  async function fetchRules() {
    setLoading(true);

    const { response, data } = await API.fetchRules();

    if (response.ok) {
      setResult(data);
    }

    setLoading(false);
  }

  useEffect(() => {
    fetchRules();
  }, []);

  return {
    loading,
    refresh: () => fetchRules(),
    rules: result?.results ?? [],
    count: result?.count ?? 0,
    limit: result?.limit ?? 0,
    page: result?.page ?? 0,
  };
}
